import React, { useContext } from 'react';
import ThrottlingCheckbox from 'integrations/components/ThrottlingCheckbox';
import AdditionalFields from 'integrations/aws/common/AdditionalFields';

import { Input } from 'components/bootstrap';

import { FormDataContext } from '../common/context/FormData';
import { AdvancedOptionsContext } from '../common/context/AdvancedOptions';
import type { HandleFieldUpdateType, FormDataContextType, AdvancedOptionsContextType } from '../common/utils/types';

interface Props {
  onChange: HandleFieldUpdateType;
  handleReadTimeOffsetChange: (...args: any[]) => void;
}

const FormAdvancedOptions = ({ onChange, handleReadTimeOffsetChange }: Props) => {
  const { formData } = useContext<FormDataContextType>(FormDataContext);
  const { isAdvancedOptionsVisible, setAdvancedOptionsVisibility } =
    useContext<AdvancedOptionsContextType>(AdvancedOptionsContext);

  const { graphThrottleEnabled, readTimeOffset } = formData;

  const handleToggle: (visible: boolean) => void = (visible) => {
    setAdvancedOptionsVisibility(visible);
  };

  const internalHandleReadTimeOffsetChange = (e) => {
    const { value } = e.target;

    if (value >= 0) {
      onChange(e);
      handleReadTimeOffsetChange('');
    } else {
      handleReadTimeOffsetChange('Read Time Offset cannot be negative');
    }
  };

  return (
    <AdditionalFields title="Advanced Options" visible={isAdvancedOptionsVisible} onToggle={handleToggle}>
      <ThrottlingCheckbox id="graphThrottleEnabled" defaultChecked={graphThrottleEnabled?.value} onChange={onChange} />
      <Input
        id="readTimeOffset"
        type="number"
        value={readTimeOffset.value}
        min="0"
        onChange={internalHandleReadTimeOffsetChange}
        required
        help="How long to wait for logs to become available in the Microsoft Graph API before attempting to read them."
        label="Read Time Offset (minutes)"
      />
    </AdditionalFields>
  );
};

export default FormAdvancedOptions;
